//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

export enum INSTAGRAM_POST_DETAILS_MODAL_ACTIONS {
  TOGGLE_REMOVE_FIELDS_MODAL = 'INSTAGRAM_POST_DETAILS_MODAL_ACTIONS/TOGGLE_REMOVE_FIELDS_MODAL',
  TOGGLE_DEFAULTS_MODAL = 'INSTAGRAM_POST_DETAILS_MODAL_ACTIONS/TOGGLE_DEFAULTS_MODAL',
  TOGGLE_VIDEO_THUMBNAIL_MODAL = 'INSTAGRAM_POST_DETAILS_MODAL_ACTIONS/TOGGLE_VIDEO_THUMBNAIL_MODAL',
  TOGGLE_CANCEL_CHANGES_MODAL = 'INSTAGRAM_POST_DETAILS_MODAL_ACTIONS/TOGGLE_CANCEL_CHANGES_MODAL',
  TOGGLE_SWAP_SCHEDULED_TO_DRAFT_MODAL = 'INSTAGRAM_POST_DETAILS_MODAL_ACTIONS/TOGGLE_SWAP_SCHEDULED_TO_DRAFT_MODAL',
  TOGGLE_ADD_MEDIA_MODAL = 'INSTAGRAM_POST_DETAILS_MODAL_ACTIONS/TOGGLE_ADD_MEDIA_MODAL',
}

export interface IInstagramPostDetailsModalState {
  isRemoveFieldsModalOpen: boolean;
  isDefaultsModalOpen: boolean;
  isVideoThumbnailModalOpen: boolean;
  isCancelChangesModalOpen: boolean;
  isSwapScheduledToDraftModalOpen: boolean;
  isAddMediaModalOpen: boolean;
}
